//MAP ON FULL SCREEN
import React, { useState, useEffect, useRef } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import Layouts from "../../layouts/layouts";
import {
  GoogleMap,
  LoadScript,
  Marker,
  DirectionsRenderer,
  InfoWindow,
} from "@react-google-maps/api";
import moment from "moment";

const containerStyle = {
  width: "100vw", // Full viewport width
  height: "100vh", // Full viewport height
  position: "absolute", // Ensure it covers the full screen
  top: 0,
  left: 0,
};

export default function MyMapComponent() {
  const { id } = useParams();
  const location = useLocation();
  const mapRef = useRef(null);
  const [pathCoordinates, setPathCoordinates] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [selectedDate, setSelectedDate] = useState(
  //   location.state?.date || new Date().toISOString().slice(0, 10)
  // );
  const [selectedDate, setSelectedDate] = useState(
    location.state?.date || new Date().toISOString().slice(0, 10),
  );

  const [numberPlate, setNumberPlate] = useState(
    location.state?.numberPlate || "",
  );
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [directions, setDirections] = useState(null);

  useEffect(() => {
    // const { date } = location.state || {};
    // if (date) {
    //   setSelectedDate(date);
    //   fetchVehicleData(date);
    // }
    const { date, numberPlate } = location.state || {};

    if (date && numberPlate) {
      setSelectedDate(date);
      setNumberPlate(numberPlate);
      fetchVehicleData(numberPlate, date);
    }
  }, [location.state]);

  const fetchVehicleData = async (numberplate, date) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      // const response = await axios.get(
      //   `${process.env.REACT_APP_BASE_URL}/api/v1/vehicleHistory/vehicle/${id}`,
      //   {
      //     headers: {
      //       "Content-Type": "application/json",
      //       Authorization: `Bearer ${token}`,
      //     },
      //   },
      // );

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/vehicle-history/numberplate/${numberPlate}/${date}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      console.log("API RESPONSE", response.data);
      const locationData = response.data.vehicleHistory || [];

      const coordinates = locationData
        // .filter(
        //   (location) => moment(location.lastDate).format("YYYY-MM-DD") === date,
        // )
        .map((location) => {
          if (
            location.coordinates &&
            location.coordinates.latitude &&
            location.coordinates.longitude
          ) {
            return {
              lat: parseFloat(location.coordinates.latitude),
              lng: parseFloat(location.coordinates.longitude),
              locationName: location.locationName || "Unknown location",
            };
          }
          return null;
        })
        .filter((coord) => coord !== null);

      setPathCoordinates(coordinates);
    } catch (error) {
      console.error("Error fetching vehicle data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchDirections = async (coordinates) => {
    if (coordinates.length < 2) return;

    const maxWaypoints = 23; // 1 origin + 1 destination + 23 waypoints = 25 total

    const directionsService = new window.google.maps.DirectionsService();
    const directionResults = [];

    let start = 0;
    while (start < coordinates.length - 1) {
      const origin = coordinates[start];
      const end =
        coordinates[Math.min(start + maxWaypoints + 1, coordinates.length - 1)];
      const waypointSlice = coordinates.slice(
        start + 1,
        Math.min(start + maxWaypoints + 1, coordinates.length - 1),
      );

      const waypoints = waypointSlice.map((coord) => ({
        location: { lat: coord.lat, lng: coord.lng },
        stopover: false,
      }));

      await new Promise((resolve) => {
        directionsService.route(
          {
            origin,
            destination: end,
            waypoints,
            travelMode: window.google.maps.TravelMode.DRIVING,
          },
          (result, status) => {
            if (status === window.google.maps.DirectionsStatus.OK) {
              directionResults.push(result);
            } else {
              console.error("Error fetching directions chunk:", status);
            }
            resolve();
          },
        );
      });

      start += maxWaypoints;
    }

    setDirections(directionResults); // Now directions is an array of multiple routes
  };

  // const fetchDirections = async (coordinates) => {
  //   if (coordinates.length < 2) return;

  //   const origin = coordinates[0];
  //   const destination = coordinates[coordinates.length - 1];
  //   const waypoints = coordinates.slice(1, -1).map((coord) => ({
  //     location: { lat: coord.lat, lng: coord.lng },
  //     stopover: false,
  //   }));

  //   const directionsService = new window.google.maps.DirectionsService();
  //   directionsService.route(
  //     {
  //       origin,
  //       destination,
  //       waypoints,
  //       travelMode: window.google.maps.TravelMode.DRIVING,
  //     },
  //     (result, status) => {
  //       if (status === window.google.maps.DirectionsStatus.OK) {
  //         setDirections(result);
  //       } else {
  //         console.error("Error fetching directions:", status);
  //       }
  //     }
  //   );
  // };

  useEffect(() => {
    if (pathCoordinates.length > 1) {
      fetchDirections(pathCoordinates);
    }
  }, [pathCoordinates]);

  const handleMarkerClick = (marker) => {
    setSelectedMarker(marker);
  };

  const handleInfoWindowCloseClick = () => {
    setSelectedMarker(null);
  };

  return (
    <>
      <Layouts />
      <LoadScript googleMapsApiKey={process.env.REACT_APP_BASE_API}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={pathCoordinates[0] || { lat: 30.7067034, lng: 76.6877915 }}
          zoom={12}
          onLoad={(map) => (mapRef.current = map)}
        >
          {loading ? (
            <div>Loading...</div>
          ) : (
            <>
              {pathCoordinates.map((coord, index) => (
                <Marker
                  key={index}
                  position={coord}
                  label={(index + 1).toString()}
                  onClick={() => handleMarkerClick(coord)}
                />
              ))}

              {/* {directions && <DirectionsRenderer directions={directions} />} */}
              {Array.isArray(directions) &&
                directions.map((dir, idx) => (
                  <DirectionsRenderer key={idx} directions={dir} />
                ))}

              {selectedMarker && (
                <InfoWindow
                  position={selectedMarker}
                  onCloseClick={handleInfoWindowCloseClick}
                >
                  <div>
                    <h4>{selectedMarker.locationName}</h4>
                    <p>
                      Coordinates: {selectedMarker.lat}, {selectedMarker.lng}
                    </p>
                  </div>
                </InfoWindow>
              )}
            </>
          )}
        </GoogleMap>
      </LoadScript>
    </>
  );
}
